import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { News } from 'src/app/models/obs/news';
import { AccessService } from 'src/app/services/access.service';
import { NewsService } from 'src/app/services/obs/news.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';

@Component({
  selector: 'app-admmeeting-list',
  templateUrl: './admmeeting-list.component.html',
  styleUrl: './admmeeting-list.component.scss'
})
export class AdmmeetingListComponent implements OnInit {

  news: News[] = [];
  msg: Message;
  idnewsSelected: string = null;

  filteredData: any[] = [];

  filtersAvailable = {
    years: [] as number[],
  };

  filters = {
    searchText: '',
    estado: null as boolean | null,
    autor: '',
    year: null as number | null,
  };

  constructor(
    private newS: NewsService,
    private activedRoute: ActivatedRoute,
    private accesService: AccessService,
    private ts: TokenStorageService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idnewsSelected = params['idnews'];
    this.getAllNews();
    this.getPermission();
  }

  //bandera que controla la creacion de contenido
  accessMP: boolean = false
  //bandera que controla la eliminacion de contenido
  accessME: boolean = false
  //bandera que controla la eliminacion de contenido
  accessMD: boolean = false
  /* Permite determinar si el usuario actual tiene permiso para el modulo */
  inf = {}
  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 8;
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'].create;
        this.accessME = res['result'].edit;
        this.accessMD = res['result'].del;
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  getAllNews() {
    this.newS.getAllEvAdm().subscribe({
      next: res => {
        this.news = res['data'];
        this.filteredData = [...this.news];
        this.getUniqueYears();
        this.applyFilter();
      },
      error: err => {
        this.msg = err;
      }
    });
  }
  // Metodo de filtro
  applyFilter(): void {
    this.filteredData = this.news.filter(obj => {
      const updatedYear = !isNaN(new Date(obj.date).getTime()) ? new Date(obj.date).getFullYear() : null;
      return (
        (this.filters.searchText
          ? obj.title.toLowerCase().includes(this.filters.searchText.toLowerCase()) ||
          obj.autor.toLowerCase().includes(this.filters.searchText.toLowerCase())
          : true) &&
        (this.filters.estado !== null ? obj.status === this.filters.estado : true) &&
        (this.filters.year !== null ? updatedYear === this.filters.year : true)
      );
    });
  }
  //Obtener los años para el combo
  getUniqueYears(): void {
    const years = this.news.map(obj => new Date(obj.date).getFullYear());
    const uniqueYears = Array.from(new Set(years));
    this.filtersAvailable.years = uniqueYears.sort((a, b) => b - a);
  }

}
